'use client';
import React from 'react';
import { useField } from 'formik';
import Image from '@repo/ui/src/components/Image';
import { readFile } from '@repo/ui/src/utils/image';
import Input from './Input';

interface Props {
  accept?: string;
  id: string;
  name: string;
  src?: string;
  photoUpload?: string;
  isEditing?: boolean;
  deletePhoto?: string;
}

const DEFAULT_SRC = '/icons/account.svg';

const ImageUpload = ({ src, ...props }: Props) => {
  const [, , helpers] = useField(props);
  const [fileUrl, setFileUrl] = React.useState(src ?? DEFAULT_SRC);

  React.useEffect(() => {
    //@ts-expect-error ts doesn't like it
    if (!(src instanceof File)) {
      setFileUrl(src ?? DEFAULT_SRC);
    }
  }, [src]);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e?.target?.files?.[0];

    if (file) {
      const sourceImage = await readFile(file);
      setFileUrl(sourceImage);
      helpers.setValue(file);
    }
  };

  const handleDelete = () => {
    setFileUrl(DEFAULT_SRC);
    helpers.setValue(null);
  };

  return (
    <div>
      <div className="bg-warm-300 overflow-hidden w-[150px] h-[150px] rounded-full relative -z-1">
        <div className="relative w-full h-full">
          <Image src={fileUrl} alt="image preview" layout="fill" objectFit="cover" />
        </div>
      </div>
      {props.isEditing && (
        <>
          <Input
            type="file"
            inputStyles="hidden"
            onChange={handleChange}
            {...props}
            value={undefined}
            label={props.photoUpload}
            labelStyles="underline text-center cursor-pointer pt-2"
          />
          {fileUrl !== DEFAULT_SRC && (
            <button
              type="button"
              onClick={handleDelete}
              className="underline text-center cursor-pointer block w-full pt-1 tra-text-web-body-m"
            >
              {props?.deletePhoto}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ImageUpload;
